import mapa from '../../assets/pictures/historia/mapa.png'
import aguaAzul from '../../assets/pictures/historia/agua_azul.jpg'
import matriz from '../../assets/pictures/historia/matriz.jpeg'
import TitleAbout from '../../components/Title'
import Ouvidoria from '../../components/Ouvidoria'


export function History() {
  return (
    <>
    <TitleAbout name="Conheça a Séculos" link1={"Home / "} link2="Conheça a Séculos" />
    <div className="flex flex-col items-center bg-gray-100 p-8">
      <div className="py-10 bg-gray-100">
        <div className="container flex flex-col lg:flex-row items-center gap-10 px-4 lg:px-20">
          {/* Texto Descritivo */}
          <div className="flex-1 max-w-md">
            <h2 className="text-3xl font-bold mb-4">Conheça a Séculos Engenharia</h2>
            <p className="text-lg leading-relaxed mb-2">
              Fundada em 1995, em Belém, a Séculos Engenharia e Serviços LTDA. é uma empresa paraense com forte atuação na região. 
              Desde 2000, nossa sede está em Parauapebas/PA, reforçando nosso compromisso com o desenvolvimento local.
            </p>
          </div>

          {/* Imagem Circular */}
          <div className="flex-1 max-w-md">
            <div className="w-full bg-cover bg-center overflow-hidden shadow-lg">
              <img
                src={matriz}
                alt="Sede da Séculos Engenharia"
                className="object-cover"
                width={550}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="text-left mt-35 mb-10">
        <h1 className="text-4xl mb-5 font-bold">VOCÊ SABIA?</h1>
        <p className="text-lg">
          A Séculos possui presença forte no Norte e Nordeste brasileiro;
        </p>
      </div>

      <div className="relative mt-10 flex flex-col items-center max-w-4xl">
        {/* Mapa do Brasil */}
        <img src={mapa} alt="Mapa do Brasil" className='' width={820} />

        {/* Texto no mapa */}
        <div className="absolute left-1 top-120 text-center mr-3">
          <p className="font-bold text-lg">Já realizamos projetos nos estados de:</p>
          <p className='text-lg'>Mato Grosso do Sul, Minas Gerais e Piauí.</p>
        </div>
        <div className="text-center mt-16">
          <p className="text-lg">Estamos preparados para atuar em todo território nacional,</p>
          <p className="text-lg">oferecendo serviços de alta qualidade!</p>
        </div>
      </div>

      <div className="mt-15 text-center">
        <h2 className="text-3xl font-bold mb-4">Operações Ativas</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Operação Água Azul do Norte */}
          <div className="bg-white shadow-lg rounded-lg p-4 transform hover:scale-105 hover:-translate-y-2 transition-all duration-300">
            <img
              src={aguaAzul}
              alt="Água Azul do Norte"
              className="rounded-lg mb-4 hover:scale-110 transition-transform duration-300"
            />
            <h3 className="font-bold text-lg">Água Azul do Norte - PA</h3>
            <p>Proj. Mina Pedra Branca - Oz Minerals</p>
          </div>

          {/* Operação Canaã dos Carajás */}
          <div className="bg-white shadow-lg rounded-lg p-4 transform hover:scale-105 hover:-translate-y-2 transition-all duration-300">
            <img
              src={aguaAzul}
              alt="Canaã dos Carajás"
              className="rounded-lg mb-4 hover:scale-110 transition-transform duration-300"
            />
            <h3 className="font-bold text-lg">Canaã dos Carajás - PA</h3>
            <p>
              Proj. Exploração - Oz Minerals
              <br />
              Proj. Santa Lúcia - Oz Minerals
              <br />
              Proj. Sossego Ore Sorting - Vale
              <br />
              Proj. S11D - Vale
              <br />
              Proj. Ferramentaria - Vale
            </p>
          </div>

          {/* Outras operações */}
          <div className="bg-white shadow-lg rounded-lg p-4 transform hover:scale-105 hover:-translate-y-2 transition-all duration-300">
            <img
              src={aguaAzul}
              alt="Ourilândia do Norte"
              className="rounded-lg mb-4 hover:scale-110 transition-transform duration-300"
            />
            <h3 className="font-bold text-lg">Ourilândia do Norte - PA</h3>
            <p>Proj. Pantera - Oz Minerals</p>
          </div>

          <div className="bg-white shadow-lg rounded-lg p-4 transform hover:scale-105 hover:-translate-y-2 transition-all duration-300">
            <img
              src={aguaAzul}
              alt="Marabá"
              className="rounded-lg mb-4 hover:scale-110 transition-transform duration-300"
            />
            <h3 className="font-bold text-lg">Marabá - PA</h3>
            <p>Proj. Salobo Metais - Vale</p>
          </div>

          <div className="bg-white shadow-lg rounded-lg p-4 transform hover:scale-105 hover:-translate-y-2 transition-all duration-300">
            <img
              src={aguaAzul}
              alt="Curionópolis"
              className="rounded-lg mb-4 hover:scale-110 transition-transform duration-300"
            />
            <h3 className="font-bold text-lg">Curionópolis - PA</h3>
            <p>Proj. Antas Norte - Oz Minerals</p>
          </div>

          <div className="bg-white shadow-lg rounded-lg p-4 transform hover:scale-105 hover:-translate-y-2 transition-all duration-300">
            <img
              src={aguaAzul}
              alt="Parauapebas"
              className="rounded-lg mb-4 hover:scale-110 transition-transform duration-300"
            />
            <h3 className="font-bold text-lg">Parauapebas - PA</h3>
            <p>
              Administrativo - Séculos
              <br />
              Proj. Exploração - Oz Minerals
            </p>
          </div>
        </div>
      </div>
    </div>
    <Ouvidoria/>
    </>
  )
}